; (function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('collectionItem', collectionItem)

  /* @ngInject */
  function collectionItem () {
    return {
      restrict: 'E',
      replace: false,
      scope: {
        collection: '<',
        collectionParam: '=',
        selectedCollections: '<',
        selectedTemplates: '<',
        change: '&',
        isSearch: '=',
        onCardClick: '&',
        selected: '=',
        shouldDragCards: '<',
        isProductList: '=',
        onCardDoubleClick: '=',
        isPublicCampaign: '=',
        linkUuid: '=',
        checkbox: '<',
        disabled: '<'
      },
      templateUrl: '/arts/directives/collection-item/collection-item-directive.html?$$REVISION$$',
      controller: 'CollectionItemController'
    }
  }
})()
